import { render, staticRenderFns } from "./selectSize.vue?vue&type=template&id=5a324706"
import script from "./selectSize.vue?vue&type=script&lang=js"
export * from "./selectSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports